import Field from "@/components/form/Field.tsx";
import cover_lojalitas from "@/assets/editor/cover/borito1small.png";
import cover_tulajdonos from "@/assets/editor/cover/borito2small.png";
import cover_szindikatus from "@/assets/editor/cover/borito3small.png";
import cover_generacio from "@/assets/editor/cover/borito4small.png";
import cover_nyugdij from "@/assets/editor/cover/borito5small.png";
import cover_premium from "@/assets/editor/cover/borito6small.png";
import cover_torzsgarda from "@/assets/editor/cover/borito7small.png";
import cover_cegert from "@/assets/editor/cover/borito8small.png";
import Theme from "@/components/editor/fields/Theme.tsx";

export default function ThemeSelector() {

    function getCheckboxActions(theme: string, field: FieldRenderProps) {
        const checked = field.value?.[theme];
        const onCheckedChange = () => {
            if (checked) {
                field.onChange({...field.value, [theme]: false});
            } else {
                field.onChange({...field.value, [theme]: true});
            }
        }
        return {checked, onCheckedChange};
    }

    return (
        <div className={"w-full h-full grid grid-cols-2"}>
            <Field defaultValue={{}} name={"theme"}>{(themeField) => (
                <Field name={"boritok"}>{(boritoField) => (
                    <>
                        <Theme title={"Lojalitás program"} img={cover_lojalitas} name={"lojalitas"}
                               checkboxActions={getCheckboxActions('lojalitas', themeField)}
                               imageActions={getCheckboxActions('lojalitas', boritoField)}>

                        </Theme>
                        <Theme title={"Tulajdonosi tőkeképzés"} img={cover_tulajdonos} name={"tokekepzes"}
                               checkboxActions={getCheckboxActions('tokekepzes', themeField)}
                               imageActions={getCheckboxActions("tokekepzes", boritoField)}>

                        </Theme>
                        <Theme title={"Törzsgárda"} img={cover_torzsgarda} name={"torzsgarda"}
                               checkboxActions={getCheckboxActions('torzsgarda', themeField)}
                               imageActions={getCheckboxActions("torzsgarda", boritoField)}>
                        </Theme>
                        <Theme title={"Szindikátusi szerződés"} img={cover_szindikatus} name={"szindikatus"}
                               checkboxActions={getCheckboxActions('szindikatus', themeField)}
                               imageActions={getCheckboxActions("szindikatus", boritoField)}></Theme>
                        <Theme title={"Generációváltás"} img={cover_generacio}
                               checkboxActions={getCheckboxActions('generacio', themeField)} name={"generacio"}
                               imageActions={getCheckboxActions("generacio", boritoField)}></Theme>
                        <Theme title={"Nyugdíj program"} img={cover_nyugdij}
                               checkboxActions={getCheckboxActions('nyugdij', themeField)} name={"nyugdij"}
                               imageActions={getCheckboxActions("nyugdij", boritoField)}></Theme>

                        <Theme title={"Prémium borító"} img={cover_premium}
                               checkboxActions={getCheckboxActions('premium', boritoField)} name={"premium"}
                               imageActions={getCheckboxActions("premium", boritoField)}></Theme>

                        <Theme checkboxActions={getCheckboxActions("ai", themeField)}
                               imageActions={getCheckboxActions("ai", boritoField)} img={cover_cegert}
                               title={"Cégértékelő"} name={"ai"}></Theme>
                    </>)}
                </Field>)}
            </Field>
        </div>
    )
}